import { twMerge } from "tailwind-merge";
import type { TButtonArrow } from "./types";

export const ButtonArrow = ({ direction, disabled, onClick }: TButtonArrow) => {
  const ButtonArrowElement = document.createElement("button");
  ButtonArrowElement.type = "button";
  ButtonArrowElement.className = twMerge(
    "flex items-center px-7 py-5 border border-gray-100 cursor-pointer group disabled:cursor-not-allowed",
    direction === "left" && "rotate-180",
  );
  ButtonArrowElement.disabled = disabled;

  ButtonArrowElement.innerHTML = /* html */ `
        <img src="/static/icons/blue-arrow-right.svg" alt="arrow-icon" class="object-contain group-disabled:opacity-20" />
    `;

  ButtonArrowElement.addEventListener("click", onClick);

  return ButtonArrowElement;
};
